import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Actions from "../payments/duck/actions";
import { API_URL } from "./constants";

function useGeoIp() {
  const dispatch = useDispatch();
  useEffect(() => {
    axios
      .get(`${API_URL}/v1/geoip`)
      .then(({ data }) => {
        dispatch(Actions.setLocation(data));
      })
      .catch(console.error);
  }, [dispatch]);
}

export default useGeoIp;
